import React from 'react'
import HeaderSection from '../../components/headersection/HeaderSection'
import './credit.css'
import useAppContext from '../../hook/useAppContext'

const Credit = () => {

      const {credit} = useAppContext()

      return (
            <div className="credit_content">
                  <HeaderSection title={`xatMe`}/>
                  <div className="credit_content__box">
                        <div className="credit_user">
                              <div className="credit_user__header flex">
                                    <div className="credit_user__avatar flex">
                                          <div className="credit_user__avatar_img flex">
                                                <img src={credit.avatar} alt={credit.name} />
                                          </div>
                                    </div>
                                    <div className="credit_user__data">
                                          <strong>{credit.name}</strong>
                                          <p>{credit.status}</p>
                                    </div>
                              </div>
                              <div className="credit_user__about">
                                    <p>{credit.about}<span> {credit.hastag}</span></p>
                              </div>
                              <a href={credit.link} target="_blank" rel="noreferrer">xatme.com</a>
                        </div>
                  </div>
            </div>
      )
}

export default Credit
